import { IDialogService } from "@aurelia/dialog";
import { IButton } from "@helpers/button/button";
import { toastifyError, toastifySuccess } from "@helpers/toastify";
import { bindable, IEventAggregator, inject, watch } from "aurelia";

@inject(IEventAggregator, IDialogService)
export class ButtonComponent implements IButton {
  @bindable id: string;
  @bindable label: string;
  @bindable disabled: boolean;
  @bindable toastMessage: string | null = null;
  @bindable typeButton: 'icon' | 'text';
  @bindable styleButton: 'primary' | 'secondary' | 'neutral' | 'danger' | 'success';
  @bindable buttonMode: 'color' | 'outline' | 'ghost';
  @bindable sizeButton: 'xsm' | 'sm' | 'default' | 'lg';
  @bindable icon: string;
  @bindable iconPosition: 'left' | 'right' = 'left';
  @bindable triggerFunction: Function;
  @bindable translate: string

  private isLoading: boolean = false;
  private btnClass: string;

  constructor(readonly ea: IEventAggregator, private dialogService: IDialogService) { }

  attached() {
    this.chooseClass()
  }

  @watch('sizeButton')
  handleSize() {
    this.chooseClass()
  }

  chooseClass() {
    this.btnClass = `btn btn-${this.styleButton}-${this.buttonMode} btn-${this.iconPosition}-icon btn-${this.typeButton}-${this.sizeButton}`;
  }

  async executeTriggerFunction() {
    this.isLoading = true;

    // const { dialog } = await this.dialogService.open({
    //   component: () => FullscreenSpinnerDialog,
    //   model: {},
    //   lock: true,
    //   startingZIndex: 100,
    // });

    try {
      await this.triggerFunction();

      if (this.toastMessage) {

        toastifySuccess({ message: this.toastMessage });
      }

    } catch (error) {
      console.log(error);

      toastifyError({ message: 'Ocorreu um erro ao executar a ação' });
    } finally {
      this.isLoading = false;
      // await dialog.ok();
    }

  }

}